import { render, staticRenderFns } from "./organization-branch-picker.vue?vue&type=template&id=31352291&"
import script from "./organization-branch-picker.vue?vue&type=script&lang=js&"
export * from "./organization-branch-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports